<template>
  <div class="footer2">
    <div class="row">
      <div class="col-md-6 foot-desc">
        <p>Copyright © 2019 henna speedy. All Rights Reserved</p>
      </div>
      <div class="col-md-6">
        <div class="social2">
          <a href="#">
            <i class="fa fa-facebook"></i>
          </a>
          <a href="#">
            <i class="fa fa-twitter"></i>
          </a>
          <a href="#">
            <i class="fa fa-instagram"></i>
          </a>
        </div>
      </div>
      <!--<div class="col-md-4">
        <p class="design-by2">Site designed by
          <img src="../assets/images/366-logp.png">
        </p>
      </div>--->
    </div>
  </div>
</template>

<script>
export default {
  name: "Footer2",
  mounted() {},
  methods: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="stylus">
</style>
